import React, {useLayoutEffect, useReducer} from "react";
import moment from "moment";
import Highcharts from 'highcharts';
import http from "../utils/api";
import {Paper, withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {withRouter} from 'react-router-dom';
import HighchartsReact from 'highcharts-react-official';
import FilterSaldoHoras from '../forms/FilterSaldoHoras';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import reducer from '../utils/defaultReducer';
import { getColaborador } from "../utils/storage";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getColaboradorAcessos } from '../utils/storage';


const styles = theme => ({
    container: {
        display: 'flex',
        flex: 1,
        flexGrow: 1,
        position: 'relative',
        maxWidth: '100vw',
    },
    chart: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
        padding: 25,
        margin: '0 10px',
        border: '0 !important',
        width: '100%',
        maxHeight: '100%',
        /*[prefersDarkMode]: {
            backgroundColor: '#EBEBEB',
            color: theme.palette.primary.contrastText,
        }*/
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)'
        },
        textAlign: 'center'
    },
});

const colaborador = getColaborador();

const renderColaboradorFilter = getColaboradorAcessos().find(ca => ca.codigoNivelOperacao === 'SH' || ca.codigoNivelOperacao === 'RC' )!== undefined;

function SaldoHoras(props) {
    const initialState = {
        horasLiberadas: [],
        data: {
            inicio: moment().day(1).subtract(6, 'month').format('YYYY-MM-DD'),
            fim: moment().date(1).format('YYYY-MM-DD'),
            nomeColaborador: colaborador.nome,
            codColaborador: colaborador.codigoColaborador,
            isFormSubmitting: false
        },
        loading: true
    };

    const [state, setState] = useReducer(reducer, initialState, () => initialState);

    const getChartOptions = (horasLiberadas) => {
        return {
            title: {
                text: 'Saldo de horas por período',
            },
            series: [
                {
                    name: 'Úteis',
                    formatter: console.log,
                    data: horasLiberadas?.map(hl => ({
                        y: hl.horasUteis,
                        name: moment(hl?.periodo).add(1, 'day').format('MM/YY'),
                    })),
                },
                {
                    name: 'Trabalhadas',
                    data: horasLiberadas?.map(hl => ({
                        y: hl.horasTrabalhadasTotal,
                        name: moment(hl?.periodo).add(1, 'day').format('MM/YY'),
                    })),
                },
                {
                    name: 'Exc./Dev.',
                    data: horasLiberadas?.map(hl => ({
                        y: hl.horasExcedDevid,
                        name: moment(hl?.periodo).add(1, 'day').format('MM/YY'),
                    })),
                },
                {
                    name: 'Acerto Exc./Dev.',
                    data: horasLiberadas?.map(hl => ({
                        y: hl.horasExcedDevidAcerto,
                        name: moment(hl?.periodo).add(1, 'day').format('MM/YY'),
                    })),
                },
                {
                    name: 'Sdo. Exc./Dev.',
                    data: horasLiberadas?.map(hl => ({
                        y: hl.saldoHorasExcedDevid,
                        name: moment(hl?.periodo).add(1, 'day').format('MM/YY'),
                    })),
                },
            ],
            yAxis: {
                title: {
                    text: 'Horas'
                },
                useHTML: true,
            },
            xAxis: {
                labels: {
                    useHTML: true,
                    formatter: function ({pos}) {
                        if (!Number.isInteger(pos))
                            return '';
                        return moment(horasLiberadas?.[pos]?.periodo).add(1, 'day').format('MM/YY');
                    }
                }
            }
        }
    }

    const afterChartCreated = (chart) => {
        setState({});
    }

    useLayoutEffect(() => {
        getHorasLiberadas();
    }, [])

    const getHorasLiberadas = (data = state.data) => {
        setState({...state, loading: true});
        data = {
            ...data,
            inicio: moment(data.inicio).date(1).format('YYYY-MM-DD'),
            fim: moment(data.fim).date(22).format('YYYY-MM-DD'),
        }
        if (renderColaboradorFilter){
            data['colaborador'] = data.codColaborador;
        }
        http.get(`horas-liberadas`, {
            params: data
        }).then(async ({data}) => {
            let newState = {
                horasLiberadas: data?.data ?? [],
                data: {
                    ...data,
                    isFormSubmitting: false
                },
                loading: false
            };
            if (!newState.data.codColaborador) {
                newState.data.codColaborador = colaborador.codigoColaborador;
                newState.data.nomeColaborador = colaborador.nome;
            }

            setState(newState);
        });
    }

    const {classes} = props;
    return <Grid className={classes.container}>
        <Grid container direction={'row'} justifyContent={"center"} alignContent={'center'} alignItems={'center'}
              className={classes.container}>
            <Paper className={classes.chart}>
                <FilterSaldoHoras data={state.data} onSubmit={(init, form) => getHorasLiberadas(form)}/>
                { state.loading ? 
                    <Grid container direction={'column'} justifyContent={"center"} alignContent={'center'} alignItems={'center'}>
                        <CircularProgress color="secondary"/>
                    </Grid> 
                    : 
                    <>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableCell}>Período</TableCell>
                                        <TableCell className={classes.tableCell}>Úteis</TableCell>
                                        <TableCell className={classes.tableCell}>Trabalhadas</TableCell>
                                        <TableCell className={classes.tableCell}>Exc./Dev.</TableCell>
                                        <TableCell className={classes.tableCell}>Acerto Exc./Dev.</TableCell>
                                        <TableCell className={classes.tableCell}>Sdo. Exc./Dev.</TableCell>
                                        <TableCell className={classes.tableCell}>Horas PL *</TableCell>
                                        <TableCell className={classes.tableCell}>Horas PT *</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        state.horasLiberadas.map((hl, i) => 
                                            <TableRow className={classes.tableRow} key={i}>
                                                <TableCell className={classes.tableCell}>{moment(hl?.periodo).add(1, 'day').format('MM/YY')}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasUteis}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasTrabalhadasTotal}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasExcedDevid}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasExcedDevidAcerto}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.saldoHorasExcedDevid}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasPl}</TableCell>
                                                <TableCell className={classes.tableCell}>{hl.horasPt}</TableCell>
                                            </TableRow>)
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={getChartOptions(state.horasLiberadas)}
                            callback={afterChartCreated}
                        />
                    </>
                }
            </Paper>
        </Grid>
    </Grid>
}

export default withRouter(withStyles(styles)(SaldoHoras))